<template>
  <div class="forgot-form">
    <h2>Recordar contraseña</h2>
    <hr/>
    <form @submit.prevent="rememberPassword()">
    <span>Introduce tu correo electrónico o tu nombre de usuario,
      para recibir por correo electrónico, instrucciones sobre cómo establecer una nueva contraseña.</span>
      <div class="form-item">
        <label>Usuario o email</label>
        <input type="text" v-model="username">
      </div>
      <button type="submit">Recordar</button>
    </form>
  </div>
</template>

<script>
import Api from '@/Api';

// Plugins
import notification from '@/utils/plugins/NotificationService';

export default {
  name: 'forgot-sidebar',
  data() {
    return {
      username: '',
      showPassword: false,
      submitted: false,
    }
  },
  methods: {
    rememberPassword() {
      return Api().post('reset?username=' + this.username).then(() => {
        notification.addNotification('Se ha enviado un mail a su correo', 'success', 10000);
        this.$emit("changeMode", 'login');
      }).catch(() => {
        notification.addNotification('Este usuario no existe', 'error', 10000);
      });
    }
  }
}

</script>